import type id from "./id";

const en: typeof id = {
	search_placeholder: "Search ..",
	select_row: "Select row",
	select_all: "Select all rows",
	loading: "Loading...",
	status: "Status",
	ref_id: "Ref ID",
	email: "Email",
	qty: "Qty",
	total: "Total",
	detail: "Detail",
	footer: {
		row_out_of: "of",
	},
};

export default en;
